'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cloneDeepLodash = require('lodash/cloneDeep');
var mergeLodash = require('lodash/merge');
var defaultsDeepLodash = require('lodash/defaultsDeep');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var cloneDeepLodash__default = /*#__PURE__*/_interopDefaultLegacy(cloneDeepLodash);
var mergeLodash__default = /*#__PURE__*/_interopDefaultLegacy(mergeLodash);
var defaultsDeepLodash__default = /*#__PURE__*/_interopDefaultLegacy(defaultsDeepLodash);

/******************************************************************************
 * Copyright (c) 2017, TigerGraph Inc.
 * All rights reserved.
 * Project: GVIS
 * Brief: GVIS library Utility Module.
 *
 * Created on: Oct 7th, 2016
 *      Author: Xiaoke Huang
 ******************************************************************************/

/**
 * GVIS library Utility Module.
 */
exports.Utils = void 0;
(function (_Utils) {
  function cloneDeep(obj) {
    var deep = cloneDeepLodash__default["default"](obj);
    return deep;
  }
  _Utils.cloneDeep = cloneDeep;
  function extend(destiation) {
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }
    // @ts-ignore
    return mergeLodash__default["default"].apply(this, arguments);
  }
  _Utils.extend = extend;
  function defaultsDeep(target) {
    for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      sources[_key2 - 1] = arguments[_key2];
    }
    // @ts-ignore
    return defaultsDeepLodash__default["default"].apply(this, arguments);
  }
  _Utils.defaultsDeep = defaultsDeep;
})(exports.Utils || (exports.Utils = {}));
